/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExecutionHourLacResponse } from '../../models/execution-hour-lac-response';

export interface GetFeV1OtherExecutionHourLac$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
}

export function getFeV1OtherExecutionHourLac$Json(http: HttpClient, rootUrl: string, params?: GetFeV1OtherExecutionHourLac$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExecutionHourLacResponse>> {
  const rb = new RequestBuilder(rootUrl, getFeV1OtherExecutionHourLac$Json.PATH, 'get');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExecutionHourLacResponse>;
    })
  );
}

getFeV1OtherExecutionHourLac$Json.PATH = '/v1/other/execution-hour-lac';
